import PropTypes from 'prop-types';
import { ClockCircleOutlined } from '@ant-design/icons';

const ActivityList = ({ activities }) => (
  <div className="mb-8">
    <h2 className="text-bold-x text-left mb-4">Activities</h2>
    
    {/* Timeline Container */}
    <div className="relative">
      {/* Vertical Line */}
      <div className="absolute left-[39px] top-0 bottom-0 w-[2px] bg-grey" />
      
      {/* Activities */}
      <div className="space-y-8"> {/* Reduced from space-y-16 to space-y-8 */}
        {activities.map((activity, index) => (
          <div key={index} className="flex items-start gap-8 relative">
            {/* Time Circle */}
            <div className="relative z-10">
              <div className="w-20 h-20 rounded-full border-2 border-primary bg-white flex flex-col items-center justify-center">
                <div className="text-primary text-xl">{activity.time.split(' ')[0]}</div>
                {/* Horizontal Line */}
                <div className="w-12 h-[1px] bg-primary my-1"></div>
                <div className="text-primary text-base">PM</div>
              </div>
            </div>

            {/* Activity Details */}
            <div className="pt-2">
              <h3 className="text-primary heading-medium font-medium mb-2">
                {activity.title}
              </h3>
              <div className="flex items-center gap-2 text-[#666666]">
                <ClockCircleOutlined className="text-lg" />
                <span className="text-base text-regular">{activity.duration}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

ActivityList.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.string,
      duration: PropTypes.string,
      title: PropTypes.string,
    })
  ),
};

export default ActivityList;